// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/form-flags');
require('@js/video');
require('@js/horizontal-accordion');
require('@js/faq');
require('@js/slider');
require('@js/woo');
